<template>
  <b-modal
    id="purchase-credits-modal"
    ref="modal"
    :title="title"
    size="lg" 
    centered
    hide-footer
    @hidden="onModalHidden"
  >
    <div v-if="iframeUrl" class="iframe-container">
      <!-- Loading indicator can be added here -->
      <iframe
        :src="iframeUrl"
        frameborder="0"
        width="100%"
        height="600px" 
        allowfullscreen
        @load="iframeLoaded"
      ></iframe>
    </div>
    <div v-else class="text-center p-5">
      <!-- Optional: Add a loading spinner -->
      <p>Yükleniyor...</p>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  name: 'PurchaseCreditsModal',
  components: { BModal },
  data() {
    return {
      iframeUrl: null,
      title: 'Kredi Satın Al', // Default title
      isLoading: false, 
    };
  },
  methods: {
    /**
     * Shows the modal with the specified URL.
     * @param {string} url The URL for the iframe source.
     * @param {string} [title='Kredi Satın Al'] Optional title for the modal.
     */
    show(url, title = 'Kredi Satın Al') {
      if (!url) {
        console.error('PurchaseCreditsModal: URL is required to show the modal.');
        return;
      }
      this.iframeUrl = url;
      this.title = title;
      this.isLoading = true; // Start loading state
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onModalHidden() {
      // Reset state when modal is hidden to prevent showing old content briefly
      this.iframeUrl = null;
      this.isLoading = false;
    },
    iframeLoaded() {
      // You can stop a loading indicator here if you added one
      this.isLoading = false;
      console.log("Purchase iframe loaded");
    }
  },
};
</script>

<style scoped>
.iframe-container {
  /* Make iframe responsive and occupy modal body */
  position: relative;
  padding-bottom: 150%; /* Adjust aspect ratio if needed, or use fixed height */
  height: 0;
  overflow: hidden;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

/* Alternative fixed height approach */
/* 
.iframe-container {
   height: 600px; // Or desired fixed height 
   overflow-y: auto; // Allow scrolling within the iframe if content exceeds height
}
.iframe-container iframe {
   width: 100%;
   height: 100%;
   border: none;
} 
*/

/* Optional: Style the loading state */
.text-center p {
  font-size: 1.2rem;
  color: #6c757d;
}
</style> 